import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "193.255",
  height: "250.519",
  viewBox: "0 0 193.255 250.519"
}
const _hoisted_2 = {
  id: "fangkuang",
  transform: "translate(-61.501 -83.001)"
}
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]

import { withDefaults } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'survey-svg-4-1',
  props: {
    controlColor: { default: 'var(--theme-color-1,#000)' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        id: "路径_5134",
        "data-name": "路径 5134",
        d: "M225.38,408.754l-92.528-50.848a6.93,6.93,0,0,1,0-12.155L225.38,293.9l92.528,51.851a6.93,6.93,0,0,1,0,12.155Z",
        transform: "translate(-67.252 -75.806)",
        fill: "none",
        stroke: _ctx.controlColor,
        "stroke-miterlimit": "10",
        "stroke-width": "1"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        id: "路径_5104",
        "data-name": "路径 5104",
        d: "M225.085,408.4,132.841,357.71a6.909,6.909,0,0,1,0-12.117L225.085,293.9l92.244,51.692a6.909,6.909,0,0,1,0,12.117Z",
        transform: "translate(-66.957 -96.63)",
        fill: _ctx.controlColor
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        id: "路径_5137",
        "data-name": "路径 5137",
        d: "M166.292,417.986V305.7s.288,3.036,5.127,5.7l90.707,49.846v114l-90.173-49.552S165.676,423.134,166.292,417.986Z",
        transform: "translate(-104.249 -163.464)",
        fill: _ctx.controlColor,
        opacity: "0.626"
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        id: "路径_5136",
        "data-name": "路径 5136",
        d: "M262.084,417.986V305.7s-.288,3.036-5.127,5.7l-90.707,49.846v114l90.173-49.552S262.7,423.134,262.084,417.986Z",
        transform: "translate(-7.871 -163.464)",
        fill: _ctx.controlColor,
        opacity: "0.626"
      }, null, 8, _hoisted_6),
      _createElementVNode("path", {
        id: "路径_5092",
        "data-name": "路径 5092",
        d: "M225.085,408.4,132.841,357.71a6.909,6.909,0,0,1,0-12.117L225.085,293.9l92.244,51.692a6.909,6.909,0,0,1,0,12.117Z",
        transform: "translate(-67.252 -210.9)",
        fill: _ctx.controlColor
      }, null, 8, _hoisted_7)
    ])
  ]))
}
}

})